import { useEffect, useState } from 'react';
import type { AbgleichJob } from './entities/Mitarbeiterabgleich';
import { MOCK_MITARBEITERABGLEICH_QUELLE } from './mock/mitarbeiterabgleich.mock';

const MOCK_JOB_DAUER_MS = 3000;

function neuester(jobs: AbgleichJob[]): AbgleichJob | undefined {
  return jobs.reduce<AbgleichJob | undefined>(
    (a, b) => (!a || b.gestartetAm > a.gestartetAm ? b : a),
    undefined,
  );
}

export function useAbgleichJobs(): {
  letzterJob?: AbgleichJob;
  letzterAbruf?: string;
  starteAbgleich: () => void;
} {
  const [jobs, setJobs] = useState<AbgleichJob[]>(() => [
    {
      id: 'initial',
      status: 'beendet',
      gestartetAm: MOCK_MITARBEITERABGLEICH_QUELLE.letzterAbruf,
    },
  ]);

  const letzterJob = neuester(jobs);
  const letzterAbruf = neuester(
    jobs.filter((job) => job.status === 'beendet'),
  )?.gestartetAm;
  const laeuft = letzterJob?.status === 'inProgress';

  // Mock: ersetzt die Backend-Mutation, bis es einen echten Job gibt.
  useEffect(() => {
    if (!laeuft) {
      return;
    }
    const timeout = setTimeout(() => {
      setJobs((alle) => alle.map((job) => ({ ...job, status: 'beendet' })));
    }, MOCK_JOB_DAUER_MS);
    return () => clearTimeout(timeout);
  }, [laeuft]);

  const starteAbgleich = () => {
    setJobs((alle) => [
      ...alle,
      {
        id: crypto.randomUUID(),
        status: 'inProgress',
        gestartetAm: new Date().toISOString(),
      },
    ]);
  };

  return { letzterJob, letzterAbruf, starteAbgleich };
}
